// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAlertsStatusCircle_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.9973 11.9998C21.9973 11.1676 21.8957 10.3593 21.7041 9.58637 22.3714 9.34441 22.9726 8.96443 23.4731 8.48094 23.8139 9.59373 23.9973 10.7753 23.9973 11.9998 23.9973 16.2381 21.7999 19.9632 18.4823 22.0981L17.4018 20.4148C20.1663 18.6358 21.9973 15.5316 21.9973 11.9998ZM16.8337 1.01443C16.2929 1.45735 15.8466 2.0114 15.5297 2.6417 14.4315 2.22693 13.241 1.99996 11.9975 1.99996 7.14611 1.99996 3.10162 5.45472 2.19001 10.0382L.228511 9.64595C1.32244 4.14571 6.17583 0 11.9975 0 13.7182 0 15.3543.362166 16.8337 1.01443ZM11.9975 23.9995C6.17583 23.9995 1.32244 19.8538.228511 14.3536L2.19001 13.9613C3.10162 18.5448 7.14611 21.9996 11.9975 21.9996 12.3996 21.9996 12.7962 21.9758 13.1859 21.9297L13.4231 23.9157C12.9556 23.971 12.4799 23.9995 11.9975 23.9995Z" class="svg-bg"/>
  <path d="M11.9998 19.9996C16.4179 19.9996 19.9996 16.4179 19.9996 11.9998H17.9996C17.9996 15.3134 15.3134 17.9996 11.9998 17.9996C8.68612 17.9996 5.99988 15.3134 5.99988 11.9998C5.99988 8.68611 8.68611 5.99988 11.9998 5.99988V3.99992C7.58157 3.99992 3.99992 7.58157 3.99992 11.9998C3.99992 16.4179 7.58157 19.9996 11.9998 19.9996Z" class="svg-bg"/>
  <circle cx="20" cy="4.885" r="3" fill="#3AD2A3"/>
  <circle cx="20" cy="4.885" r="3" stroke="white"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 19.8816C1.73465 26.8425 8.02799 32 15.5259 32 15.6145 32 15.7029 31.9993 15.7912 31.9978L15.7575 29.9981C15.6805 29.9994 15.6033 30 15.5259 30 8.96523 30 3.45857 25.4872 1.94074 19.3964L0 19.8816ZM22.3293 28.2387C26.6221 25.8472 29.5259 21.2627 29.5259 16 29.5259 14.7687 29.367 13.5745 29.0685 12.4369 29.7165 12.1335 30.3014 11.7176 30.798 11.2145 31.271 12.7255 31.5259 14.333 31.5259 16 31.5259 22.0149 28.2068 27.2547 23.3002 29.9876L22.3293 28.2387ZM23.2407 1.97942C20.9529.717862 18.3232 0 15.5259 0 8.02799.00000208574 1.73465 5.1575 0 12.1184L1.94074 12.6036C3.45857 6.5128 8.96523 2 15.5259 2 17.7429 2 19.8395 2.51531 21.7025 3.43269 22.1249 2.86231 22.6461 2.36947 23.2407 1.97942Z" class="svg-bg"/>
  <path d="M27.3619 18C26.4097 23.6754 21.4738 28 15.5278 28C8.90039 28 3.52781 22.6274 3.52781 16C3.52781 9.37258 8.90039 4 15.5278 4V6C10.005 6 5.52781 10.4772 5.52781 16C5.52781 21.5228 10.005 26 15.5278 26C20.3657 26 24.4012 22.5645 25.3278 18H27.3619Z" class="svg-bg"/>
  <circle cx="26.527" cy="7" r="4" fill="#3AD2A3"/>
  <circle cx="26.527" cy="7" r="4" stroke="white"/>
</svg>
`;
/**
 * IconAlertsStatusCircle is a generated icon component.
 */
let IconAlertsStatusCircle = IconAlertsStatusCircle_1 = class IconAlertsStatusCircle extends IconBaseElement {
    render() {
        return html `${IconAlertsStatusCircle_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAlertsStatusCircle.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconAlertsStatusCircle = IconAlertsStatusCircle_1 = __decorate([
    customElement('zui-icon-alerts-status-circle')
], IconAlertsStatusCircle);
export { IconAlertsStatusCircle };
